import React from "react";

const courses = [
  {
    title: "Judo Enfant",
    desc: "Jeux, sécurité, valeurs du judo et bases techniques dans un cadre bienveillant.",
    icon: "👦",
    tag: "5 – 13 ans",
    accent: "#f5c518",
  },
  {
    title: "Technique Débutant",
    desc: "Fondamentaux solides : chutes, mobilité, contrôles et culture du tatami.",
    icon: "🥋",
    tag: "Tous niveaux",
    accent: "#4ade80",
  },
  {
    title: "Technique Expérimenté",
    desc: "Enchaînements avancés, stratégie de combat et intensité maîtrisée.",
    icon: "⚡",
    tag: "+1 an de pratique",
    accent: "#60a5fa",
  },
  {
    title: "Compétition",
    desc: "Prépa spécifique : randori intense, tactique, arbitrage et gestion du stress.",
    icon: "🏆",
    tag: "Niveau compétiteur",
    accent: "#f97316",
  },
];

export default function CoursesSection() {
  return (
    <section id="cours" className="section alt">
      <div className="container">
        <div data-reveal="up">
          <span className="section-label">🥋 Programmes</span>
          <h2 className="section-title">Nos Cours</h2>
          <p className="section-sub">4 niveaux pour progresser à ton rythme, de 5 ans à l'élite.</p>
        </div>

        <ul className="course-cards">
          {courses.map((c, i) => (
            <li
              key={c.title}
              className="course-card"
              style={{ "--accent": c.accent }}
              data-reveal="up"
              data-delay={String(i + 1)}
            >
              <div className="course-icon-wrap">{c.icon}</div>
              <span className="course-tag">{c.tag}</span>
              <h3 className="course-name">{c.title}</h3>
              <p className="course-desc">{c.desc}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
